export const BILLING_ENDPOINT = `https://${process.env.NEXT_PUBLIC_BILLING_SERVICE_DOMAIN_NAME}`;
